import { useDroppable } from '@dnd-kit/core'
import React, { useRef } from 'react'

import { RowContainer } from './components'
import { useDynamicCellSize, usePageContainerWidth } from './hooks'
import type { DashboardGridProps } from './types'

export const DashboardGrid: React.FC<DashboardGridProps> = ({
	rows,
	activeId,
	pageContainerRef,
	onReorderWidgetsInRow,
	onDropWidget,
}) => {
	const { setNodeRef } = useDroppable({ id: 'dashboard-dropzone' })

	// Используем переданный ref или создаем fallback
	const fallbackRef = useRef<HTMLDivElement>(null)
	const containerRef = pageContainerRef || fallbackRef
	const pageContainerWidth = usePageContainerWidth(containerRef)

	// Вычисляем динамический размер ячейки
	const cellSize = useDynamicCellSize({
		pageContainerWidth,
	})

	return (
		<div ref={setNodeRef} style={{ width: '100%' }}>
			{rows.map((row, index) => (
				<RowContainer
					key={row.id}
					row={row}
					activeId={activeId}
					onReorderWidgets={widgets => onReorderWidgetsInRow(row.id, widgets)}
					onDropWidget={widget => onDropWidget(row.id, widget)}
					customCellSize={cellSize}
					showInsertZoneBefore={index === 0}
					showInsertZoneAfter={true}
				/>
			))}
		</div>
	)
}
